import Swiper from 'swiper';

export default class Slider {
  constructor(selector, config = {}, replaceAll = false) {
    this.sliderNode = document.querySelector(selector);

    if(this.sliderNode) {
      new Swiper(
        this.sliderNode,
        replaceAll ? config : Object.assign({}, Slider.getDefaultConfig(), config)
      );
    }

  }

  static getDefaultConfig() {
    return {
      loop: true,
      speed: 500,
      navigation: {
        nextEl: '.js-slider-next',
        prevEl: '.js-slider-prev',
      },
      autoplay: {
        delay: 6000,
        stopOnLastSlide: false,
        disableOnInteraction: true,
      },
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/modules/slider.js